/* gg-menu-testata.js · 27/10/2026 (Luca, task 1 di post-go-live, come Handly Atelier): col menu del telefono aperto la testata resta
   ferma. Misura dove finisce la testata (--gg-testata, per gg-chrome.css), mette la X accanto alle tre righe e la mostra a menu aperto
   (html.gg-menu-aperto), e il tocco sulla X chiude il menu invece di riaprirlo. */
(function () {
  var d = document.getElementById('Drawer-MobileNav'); if (!d) return;
  var html = document.documentElement;
  function misura() { var h = document.querySelector('header.site-header'); if (h) html.style.setProperty('--gg-testata', Math.max(0, Math.round(h.getBoundingClientRect().bottom)) + 'px'); }
  document.querySelectorAll('drawer-opener[data-drawer="#Drawer-MobileNav"] button').forEach(function (b) {
    if (b.querySelector('.gg-x')) return;
    b.insertAdjacentHTML('beforeend', '<svg class="gg-x f-icon-svg f-icon-svg--medium" viewBox="0 0 24 24" fill="none" aria-hidden="true" focusable="false"><path d="M6 6L18 18M18 6L6 18" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/></svg>');
  });
  new MutationObserver(function () { html.classList.toggle('gg-menu-aperto', d.hasAttribute('open')); }).observe(d, { attributes: true, attributeFilter: ['open'] });
  document.addEventListener('click', function (e) {
    var o = e.target.closest && e.target.closest('drawer-opener[data-drawer="#Drawer-MobileNav"]'); if (!o) return;
    if (d.hasAttribute('open')) { e.preventDefault(); e.stopPropagation(); if (d.closeDrawer) d.closeDrawer(); else { var x = d.querySelector('.f-drawer__close'); if (x) x.click(); } }
    else misura();
  }, true);
  misura();
})();
